import { FaTriangleExclamation } from "react-icons/fa6";
import { PaymentCardShortInfo } from "@/features/payment/types";
import { twMerge } from "tailwind-merge";
import { Chip } from "@/components/ui/Chip";
import {
  CardBrandIcon,
  CardBrandIconProps,
} from "@/features/payment/components/CardBrandIcon";

type CardStatusBadgeProps =
  | {
      type: "details";
      className?: string;
      last4ClassName?: string;
      cardInfo: PaymentCardShortInfo | null;
      iconSize?: CardBrandIconProps["size"];
    }
  | {
      type: "status";
      hasCard: boolean;
    };

export function CardChip(props: CardStatusBadgeProps) {
  if (props.type === "details") {
    if (props.cardInfo?.last4) {
      return (
        <div
          className={twMerge(
            "flex shrink-0 items-center gap-1",
            props.className,
          )}
        >
          <CardBrandIcon
            brand={props.cardInfo.brand}
            size={props.iconSize ?? "xs"}
          />
          <span
            className={twMerge(
              "text-[11px] font-bold text-[#111827]",
              props.last4ClassName,
            )}
          >
            {props.cardInfo.last4}
          </span>
        </div>
      );
    }

    return (
      <Chip variant="danger">
        <FaTriangleExclamation size={12} />
        No Card
      </Chip>
    );
  }

  if (props.type === "status") {
    return (
      <span
        className={twMerge(
          "inline-flex items-center gap-1 rounded-lg px-2.5 py-1 text-[11px] font-semibold",
          props.hasCard
            ? "text-success-teal bg-[#E6F9EE]"
            : "bg-danger-wash text-brand-red",
        )}
      >
        <div
          className={twMerge(
            "size-[5px] rounded-[3px]",
            props.hasCard ? "bg-success-teal" : "bg-brand-red",
          )}
        />
        {props.hasCard ? "Active" : "No Card"}
      </span>
    );
  }
}
